import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { registerUser } from "../api/api";
import { FaUser, FaEnvelope, FaLock, FaPhone, } from "react-icons/fa";
import "../styles/Register.css";

const Register = () => {
  const [user, setUser] = useState({
    username: "",
    email: "",
    password: "",
    phone: "",
    address: ""
  });
  const navigate = useNavigate();

  const handleChange = (e) => {
    setUser({ ...user, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await registerUser(user);
      if (response.data.message) {
        alert(response.data.message);
        navigate("/login"); // Redirect to Login page after registration
      } else {
        alert(response.data.error);
      }
    } catch (error) {
      console.error("Registration error:", error);
      alert("Registration failed. Check the console for details.");
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-box">
        <h2>Register User</h2>
        <form onSubmit={handleSubmit}>
          <div className="input-group">
            <FaUser className="icon" />
            <input
              type="text"
              name="username"
              placeholder="Username"
              value={user.username}
              onChange={handleChange}
              required
            />
          </div>
          <div className="input-group">
            <FaEnvelope className="icon" />
            <input
              type="email"
              name="email"
              placeholder="Email"
              value={user.email}
              onChange={handleChange}
              required
            />
          </div>
          <div className="input-group">
            <FaLock className="icon" />
            <input
              type="password"
              name="password"
              placeholder="Password"
              value={user.password}
              onChange={handleChange}
              required
            />
          </div>
          <div className="input-group">
            <FaPhone className="icon" />
            <input
              type="tel"
              name="phone"
              placeholder="Phone (optional)"
              value={user.phone}
              onChange={handleChange}
            />
          </div>
          <div className="input-group">
            {/* <FaHome className="icon" /> */}
            <textarea
              name="address"
              placeholder="Address (optional)"
              value={user.address}
              onChange={handleChange}
              rows={3}
            />
          </div>
          <button type="submit" className="btn-register">
            Register
          </button>
        </form>
        <div className="auth-footer">
          <p>
            Already have an account?{" "}
            <Link to="/login">Login here</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Register;
